import { defineMessages } from 'react-intl';

export default defineMessages({
  numPolice: {
    id: 'amc_details.my_contracts.num_police',
  },
  identification: {
    id: 'amc_details.my_contracts.identification',
  },
  paymentChoice: {
    id: 'amc_details.my_contracts.payment_choice',
  },
  rib: {
    id: 'amc_details.my_contracts.rib',
  },
  mandateAddress: {
    id: 'amc_details.my_contracts.mandate_address',
  },
});
